var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipData),expression:"tooltipData"}],staticClass:"badge badge-pill badge-discontinued"},[_vm._v("\n  "+_vm._s(_vm.$t('discontinued'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }